import { ExecutedFailure } from '@zoom/videosdk';

export const withTimeout = <T>(
  promise: Promise<T>,
  timeout: number,
  errorMessage?: string,
): Promise<T> =>
  // Create a timeout promise that rejects after the specified time
  Promise.race([
    promise,
    new Promise<never>((_, reject) =>
      setTimeout(
        () => reject(new Error(errorMessage || 'Timeout exceeded')),
        timeout,
      ),
    ),
  ]);
export const isZoomError = (error: any): error is ExecutedFailure => {
  return (
    error &&
    typeof error === 'object' &&
    'type' in error &&
    'reason' in error &&
    'errorCode' in error &&
    typeof error.type === 'string' &&
    typeof error.reason === 'string' &&
    typeof error.errorCode === 'number'
  );
};
